import { render, staticRenderFns } from "./DireccionDatos.vue?vue&type=template&id=128e7c8c"
import script from "./DireccionDatos.vue?vue&type=script&lang=js"
export * from "./DireccionDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports